import React, { Component } from 'react'

export default class DetailCell extends Component {
    render() {
        return (
            <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',height:'fit-content'}}>
                <div className="linkStyle" style={{fontSize:'12px',margin:'0px'}} onClick={() => this.props.getInvoiceDetail(this.props.value)}>خرید</div>
                <div style={{minWidth:'1px',backgroundColor:'var(--brown1)',margin:'0px 20px',height:'20px'}} />
                <div className="linkStyle" style={{fontSize:'12px',margin:'0px'}} onClick={() => this.props.getInvoiceCredit(this.props.value)}>اعتبار</div>
            </div>
        )
    }
}